module.exports = __webpack_public_path__ + "img/css.df53a66.svg";